import { Stack } from '@mui/material';
import LogisticaSyncControls from './logistica-sync-controls';
import FicSyncControls from './fic-sync-controls';

export default function ControlsPage() {
  return (
    <Stack spacing={3}>
      <LogisticaSyncControls />
      <FicSyncControls />
    </Stack>
  );
}
